$(document).ready(function(){

  $('body').addClass('is-loaded');
  
  gsap.registerPlugin(ScrollTrigger, ScrollSmoother, ScrollToPlugin, CustomEase, CustomWiggle);


  var vw = $(window).width();



  $('.s-notification-marquee').each(function(){	

		var speed = $(this).attr('data-marquee-speed');
		var ticketContent = $(this).find('.marquee-content');
		
		var tl = gsap.timeline({repeat: -1, repeatDelay: 0});
	
		gsap.set(ticketContent, {xPercent: 0});
		
		tl.to(ticketContent, {xPercent: -100, ease: 'linear', duration:speed});
		

		tl.pause();
		tl.resume();
		
	});


  setTimeout(function(){
    $('.option-toffee-tan').click();
  },500);
  







  function updateReview() {
    var x = $('.trustshop-total-rating').text();
   $('.review-stat').html('5.0 ('+x+')');
  }

  setTimeout(function(){
    if($('.sticky-cart__rating').length) {
      updateReview();
    }
  },2000);





  if($(window).width() > 749) {
    let simplesScroll = ScrollSmoother.create({
        smooth:  1,               // how long (in seconds) it takes to "catch up" to the native scroll position
        effects: true,           // looks for data-speed and data-lag attributes on elements
        smoothTouch: 0,        // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)
        normalizeScroll: false,
        ignoreMobileResize: true
    });
  }





  if ($('.s-timeline-end').length) {
    // $('.s-timeline-end .btn-shop-now').clone().addClass('btn-shop-now-fixed').removeClass('btn-shop-now').appendTo('body');

    ScrollTrigger.create({
      trigger: '.btn-shop-now',
      start: 'top bottom',
      end: 'bottom top',
      onEnter: function() { $('.btn-shop-now-fixed').addClass('hide'); },
      onLeave: function() { $('.btn-shop-now-fixed').removeClass('hide') },
      onEnterBack: function() { $('.btn-shop-now-fixed').addClass('hide') },
      onLeaveBack: function() { $('.btn-shop-now-fixed').removeClass('hide') }
    });

     ScrollTrigger.create({
      trigger: '.s-footer',
      start: 'top bottom',
      end: 'bottom top',
      onEnter: function() { $('.btn-shop-now-fixed').addClass('hide'); },
      onLeave: function() { $('.btn-shop-now-fixed').removeClass('hide') },
      onEnterBack: function() { $('.btn-shop-now-fixed').addClass('hide') },
      onLeaveBack: function() { $('.btn-shop-now-fixed').removeClass('hide') }
    });
    
    
  }


  $('.tax-note a').each(function(){
      var x = $(this).text();

      if(x=='shipping') {
        console.log('huy');
        $(this).attr('href','https://simpleslife.co/pages/resources?s=shipping');
      }
  });
  


  
//Create a wiggle with 6 oscillations (default type:"easeOut")
CustomWiggle.create("myWiggle", {wiggles: 6});
/*
  $('.s-product-block-heading').mouseover(function(){
    gsap.to(".s-product-block-heading", {duration: 0.5, rotation: 4, ease: "myWiggle"});
  });
  */
//now use it in an ease. "rotation" will wiggle to 30 and back just as much in the opposite direction, ending where it began.



  
  var wiggleOn = false;

  /*
  $('.anim-landing-comfort').mouseover(function(){

    
    if(!wiggleOn) {
      gsap.to($(this), {duration: 0.5, rotation: 2, ease: "myWiggle"});
      wiggleOn = true;
    } else {
      setTimeout(function(){
        wiggleOn = false;
      },1000);
    }


    
        
  });
  */


  if($('.s-404').length) {
    $('.s-footer').hide();
  }


  if($('.s-product-gallery').length) {
    $('.s-sticky-cart').addClass('fixed');
  }

 
  

  function getUrlVars() {
      var vars = {};
      var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m, key, value) {
      vars[key] = value;
      });
      return vars;
    }

    var s = getUrlVars()["s"];

  setTimeout(function(){

    if (s == 'customer-care') {
      var d = $('[data-anchor=customer-care]');
      /* $('.btn__customer-care').click(); */
      gsap.to(window, { duration: .4, scrollTo: { y: d, offsetY: 50 } });
    } else if (s == 'shipping') {
      var d = $('[data-anchor=shipping]');
      gsap.to(window, { duration: .4, scrollTo: { y: d, offsetY: 50 } });
      /* $('.btn__shipping').click(); */
    } else if (s == 'faqs') {
      /* $('.btn__ethics').click(); */
      var d = $('[data-anchor=faqs]');
      gsap.to(window, { duration: .4, scrollTo: { y: d, offsetY: 50 } });
    } else if (s == 'return-policy') {
      var d = $('[data-anchor=returns]');
      gsap.to(window, { duration: .4, scrollTo: { y: d, offsetY: 50 } });
     /* $('.btn__returns').click(); */
    } else if (s == 'reviews') {
      var d = $('.trustshop-review-wrap');
      if($(window).width() > 749) {
        var scrollOffset = 120
      } else {
        var scrollOffset = 80
      }
      
      gsap.to(window, { duration: .4, scrollTo: { y: d, offsetY: scrollOffset } });
    } else {
      
    }
    
  },1000);
    
	

  /* popup */
  /*
  if($('.section-s-popup').length) {
    $('.section-s-popup').hide().appendTo('body');

    setTimeout(function(){
        $('.section-s-popup').show();
        simplesScroll.paused(true);
    },1000);

    $('.btn__close-popup').click(function(){
      $('.section-s-popup').fadeOut(200);
      simplesScroll.paused(false);
    });
  }
  */

  

    $('.section-s-popup').hide().appendTo('body');

    if($('.s-home-landing ').length) {
      setTimeout(function(){
          
          $('.section-s-popup').fadeIn(300);
        simplesScroll.paused(true);
          
      },3000);
    }

    $('.btn__close-popup, .btn__icon-close-popup').click(function(){
      $('.section-s-popup').fadeOut(200);
      simplesScroll.paused(false);

      return false;
    });
  
  

  

  $('.s-size-selector a').click(function(){
    var variantID = $(this).attr('data-variant-id');
    $('.more-info').attr('href','/products/wonderskips?variant='+variantID);
    
    if($(this).hasClass('size-coming-soon')) {
      return false;
    }  else {
$(this).parents('ul').find('a').removeClass('active');
    $(this).addClass('active');
    }
    
  
  });

  $('.btn__add-to-cart').click(function(){
    var variantID = $(this).parents('.s-product-card').find('.active').attr('data-variant-id');
    $('.product-variant-id').attr('value',variantID);
    $(this).parents('.s-product-card').find('.buy-now-wrap .product-form__submit').click();
    //$('.product-form__submit').click();
    return false;
  });

  $('.btn__buy-it-now').click(function(){
    // var variantID = $(this).parents('.s-product-card').find('.active').attr('data-variant-id');
    // $('.product-variant-id').attr('value',variantID);
    // $('.shopify-payment-button__button').click();
    // $('gravity-button').click();
    
    console.log('hoy');

    $('shop-pay-wallet-button').trigger();


    return false;
  });

  $('.s-product-card').on('mouseover',function(){
    var variantID = $(this).find('.active').attr('data-variant-id');
    $('.product-variant-id').attr('value',variantID);
  });




    $('.s-product-card').each(function(){

      $('.featured-product .product__info-wrapper').clone().appendTo($(this).find('.buy-now-wrap'));



      console.log('1');

  });


  

  
  $('.scrollto').click(function(){
    var z = 0;
    var x = $(this).attr('href');
    var z = x.replace('#','');
    var t = $('[data-anchor='+z+']');

    if(x=='#s-footer') {
      gsap.to(window, { duration: .4, scrollTo: { y: x, offsetY: 50 } });
    } else {
      gsap.to(window, { duration: .4, scrollTo: { y: t, offsetY: 50 } });
    }

    return false;
  });

  

  /* body */

  if($('.s-home-landing').length) {

    if($(window).width() > 749) {
      $('.header__heading-logo-wrapper').addClass('hide');

      ScrollTrigger.create({
        trigger: '.s-home-logo',
        start: 'bottom top',
        end: 'bottom 50%+=100px',
        onEnter: function() { $('.header__heading-logo-wrapper').removeClass('hide'); },
        onEnterBack: function() { $('.header__heading-logo-wrapper').addClass('hide'); }
      });
      
    }
    
    $('body').append('<a href="/products/wonderskips" class="btn btn__shop-the-shoes rev">Shop Now</a>');


     ScrollTrigger.create({
        trigger: '.s-home-landing',
        start: 'bottom 90%',
        //endTrigger: '.s-footer',
        //end: 'bottom 50%+=100px',
        onEnter: function() { $('.btn__shop-the-shoes').removeClass('rev'); },
       onLeaveBack: function() { $('.btn__shop-the-shoes').addClass('rev'); },
        onEnterBack: function() { $('.btn__shop-the-shoes').addClass('rev'); }
       
    });

    ScrollTrigger.create({
        trigger: '.s-footer',
        start: 'top bottom',
        onEnter: function() { $('.btn__shop-the-shoes').addClass('hide'); },
        onEnterBack: function() { $('.btn__shop-the-shoes').removeClass('hide'); },
        onLeaveBack: function() { $('.btn__shop-the-shoes').removeClass('hide'); }
    });


    

    
    $('.s-animation-tilt').each(function(){
      var t = $(this);
      
      ScrollTrigger.create({
          trigger: t,
          start: 'top 75%',
          //end: 'bottom 50%+=100px',
          onEnter: function() {
            t.addClass('hover');

            setTimeout(function(){
              t.removeClass('hover');
            },100);
          }
      });
    });

  } 



  if($('.s-single-product').length) {

    function stickyReady() {
      var x = $('.product-form__input--swatch .form__label span').text();
      
      $('.holder-selected-swatch').html(x);

    }



  
    
    $('.product-form__buttons').each(function(){
      var x = $(this).height();
      $(this).wrap('<div class="product-form__buttons-wrap" style="min-height:'+x+'px;"></div>');
    });
    

    $('.product-form').parent('div').addClass('product-form-wrap');


    function copyBuynow() {
        $('.sticky-cart__button-group').html(' ');
        $('.product-form').clone().appendTo('.sticky-cart__button-group');
    }

    setTimeout(function(){
      
   

         ScrollTrigger.create({
        trigger: '.product-form-wrap',
        start: 'top top',
        //endTrigger: '.s-footer',
        //end: 'bottom 50%+=100px',
        onEnter: function() { $('.s-sticky-cart').addClass('show'); stickyReady();  copyBuynow(); },
        onEnterBack: function() { $('.s-sticky-cart').removeClass('show'); },
        onLeaveBack: function() { $('.s-sticky-carts').removeClass('show'); }
      });

    },500);
    

    ScrollTrigger.create({
        trigger: '.s-footer',
        start: 'top bottom',
        end: 'bottom top',
        onEnter: function() { $('.s-sticky-cart').removeClass('show'); },
        onLeave: function() { $('.s-sticky-cart').addClass('show'); },
        onEnterBack: function() { $('.s-sticky-cart').removeClass('show'); },
        onLeaveBack: function() { $('.s-sticky-cart').addClass('show'); }
        
      });


  
    
    } else {
      $('.s-sticky-cart').remove();
    }



  
  $('.sticky-cart-add').click(function(){
  
    $('.product-form__submit').click();

    return false;

  });

  $('.sticky-cart-buy').click(function(){
    return false;
  });
  

  
  $('.s-animation').each(function(){

      var t = $(this);
      var u = $(this).find('g');
      
        let tl = gsap.timeline({
    
        scrollTrigger: {
            trigger: t,
            start: 'top 90%', // when the top of the trigger hits the top of the viewport
            //end: '+=300',
            //scrub: 1 // smooth scrubbing, takes 1 second to "catch up" to the scrollbar 

          }
      });
      
      gsap.set(u, {
        opacity: 0,
         y: -250
      });
  
      
      tl.to(u, {
        opacity: 1,
        yPercent: 0,
        ease: "back.inOut(2.5)",
        y: 0,
        stagger: 0.1,
        duration: .8
      });

    
    });





  
  
  /* about */

  if($('.line').length) {
    let tl = gsap.timeline({
      // yes, we can add it to an entire timeline!
      scrollTrigger: {
          trigger: '.line',
          start: 'top 90%', // when the top of the trigger hits the top of the viewport
          scrub: 1 // smooth scrubbing, takes 1 second to "catch up" to the scrollbar 
        }
    });
    
    gsap.set('.line', {
      clipPath: 'polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)'
    });
    tl.to('.line', {
      clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)'
    });
  }


  
  $('.s-image-zoomout').each(function(){

    var t = $(this);
    var x = t.find('img');
    
    let tl = gsap.timeline({
      // yes, we can add it to an entire timeline!
      scrollTrigger: {
          trigger: t,
          start: 'top 80%', // when the top of the trigger hits the top of the viewport 
          scrub: 1 // smooth scrubbing, takes 1 second to "catch up" to the scrollbar 
        }
    });
    
    gsap.set(x, {
      scale: 1.1
    });
    
    tl.to(x, {
       scale: 1.01,
      stagger: 0.1
    });
    
  });


  $('.s-image-auto-zoomout').each(function(){

    var t = $(this);
    var x = t.find('img');
    
    let tl = gsap.timeline({
      // yes, we can add it to an entire timeline!
      scrollTrigger: {
          trigger: t,
          start: 'top 80%', // when the top of the trigger hits the top of the viewport 
          //scrub: 1 // smooth scrubbing, takes 1 second to "catch up" to the scrollbar 
        }
    });
    
    gsap.set(x, {
      scale: 1.15
    });
    
    tl.to(x, {
        scale: 1.01,
        stagger: 0.2
    });
    
  });

  if($('.s-ghs-logo-2').length) {
    var ghs = $('.s-ghs-logo-2');
    gsap.to(ghs, 12, {rotation:"-360", ease:Linear.easeNone, repeat:-1});
  }
  
  var reviewSlider = $(".s-reviews-slider").bxSlider({
    controls: false,
    speed: 800,
    auto: true,
    pause: 6500
  });

  var productGallery = $('.s-product-gallery').bxSlider({
    mode: 'horizontal',
    speed: 800,
  });




  /*
  $('variant-selects fieldset:first-child input').each(function(){
    var attr = $(this).attr('checked');

    if (typeof attr !== typeof undefined && attr !== false) {
      var x = $(this).attr('id');
      var y = x.substr(x.length - 1);

      if(y!=0) {
        setTimeout(function(){
          $('[data-color="'+y+'"]').click();
        },500);

        if(y==1) {
          $('.holder-selected-swatch').html('Grassy Green');
          $('.sticky-cart__product-image').html('<img src="https://cdn.shopify.com/s/files/1/0840/9740/1130/files/simples-wonderskips-grassy-green.jpg?v=1761866252&width=200">');
        } else if(y==2) {
          $('.holder-selected-swatch').html('Toffee Tan');
          $('.sticky-cart__product-image').html('<img src="https://cdn.shopify.com/s/files/1/0840/9740/1130/files/simples-wonderskips-toffee-tan.jpg?v=1761866252&width=200">');
        } else if(y==3) {
          $('.holder-selected-swatch').html('Bondi Blue');
          $('.sticky-cart__product-image').html('<img src="https://cdn.shopify.com/s/files/1/0840/9740/1130/files/simples-wonderskips-bondi-blue.jpg?v=1761866252&width=200">');
        } else {
          $('.holder-selected-swatch').html('Petal Pink');
        }
      }
      
    
      // console.log(y);
    }

  });
  */
  


  $('.simple-color-selector a').click(function(e){
    var x = $(this).attr('data-color');
    var colorName = $(this).attr('title');
    $('#template--25536748716330__main-1-'+x).click();
    $('.holder-color-label').html(colorName);

      if(x==0) {
        $('.holder-selected-swatch2').html('Petal Pink');
        $('.sticky-cart__product-image').html('<img src="https://cdn.shopify.com/s/files/1/0840/9740/1130/files/simples-wonderskips-petal-pink.jpg?v=1761866252&width=200">');
      } else if(x==1) {
        $('.holder-selected-swatch2').html('Grassy Green');
        $('.sticky-cart__product-image').html('<img src="https://cdn.shopify.com/s/files/1/0840/9740/1130/files/simples-wonderskips-grassy-green.jpg?v=1761866252&width=200">');
      } else if(x==2) {
        $('.holder-selected-swatch2').html('Toffee Tan');
        $('.sticky-cart__product-image').html('<img src="https://cdn.shopify.com/s/files/1/0840/9740/1130/files/simples-wonderskips-toffee-tan.jpg?v=1761866252&width=200">');
      } else if(x==3) {
        $('.holder-selected-swatch2').html('Bondi Blue');
        $('.sticky-cart__product-image').html('<img src="https://cdn.shopify.com/s/files/1/0840/9740/1130/files/simples-wonderskips-bondi-blue.jpg?v=1761866252&width=200">');
      }
      

    var y = (parseInt(x))+7;
    var z = (parseInt(x))+9;

    $('.simple-color-selector a').removeClass('active');
    $(this).addClass('active');

    // console.log(x);
    // console.log(colorName);

    if($(window).width() > 749) {
        $('.s-product-gallery-wrap .bx-pager-item:nth-child('+y+') a').click();
      } else {
        $('.s-product-gallery-wrap-sm .bx-pager-item:nth-child('+z+') a').click();
      }

    setTimeout(function(){
      gsap.to(window, { duration: .4, scrollTo: 0 });
    },500);

    e.preventDefault();

  });


  /*
$('#variant-selects-template--25536748716330__main label').click(function(e){
      var x = $(this).attr('for');
      

      if(x=='template--25536748716330__main-2-0') {
        $('.holder-selected-size').html('T4');
      } else if(x=='template--25536748716330__main-2-1') {
        $('.holder-selected-size').html('T5');
      } else {

      }

      console.log(x);
    
});

*/

$(document).on('change', 'input[type="radio"][name*="Size"]', function () {
  // console.log('fired');
  //console.log('selected value:', $(this).val());

  $('.holder-selected-size').html($(this).val());
});




setInterval(function () {
  const host = document.querySelector('#tidio-chat');

  if (host && host.shadowRoot) {
    const root = host.shadowRoot.querySelector('#tidio-chat-root');
    if (root) {
      root.style.paddingBottom = '55px';
    }
  }
}, 500);


  
  $('.s-footer-menu .item-content').each(function(){
      var w = $(this).width();
      var h = $(this).height();

      $(this).css({
        'height':h
      });

      $(this).parent('.item').addClass('hide');
  });

  
  $('.s-accordion .item-header').click(function(){

    var a = $(this).parents('.s-accordion');

    if(a.hasClass('s-footer-menu')) {

      var t = $(this).parents('.item');

      if(t.hasClass('hide')) {
        $('.s-accordion .item').addClass('hide');
        $(this).parents('.item').removeClass('hide');
        $(this).parents('.item').find('.s-icon').html('+');
      } else {
  
        $('.s-accordion .item').addClass('hide');
        $('.s-icon').html('+');
  
        $(this).parents('.item').addClass('hide');
        $(this).parents('.item').find('.s-icon').html('-');      
      }
      
      
    } else {
      
      var t = $(this).parents('.item');

      if(t.hasClass('open')) {
        $(this).parents('.item').removeClass('open');
        $(this).parents('.item').find('.s-icon').html('+');
      } else {
  
        $('.s-accordion .item').removeClass('open');
        $('.s-icon').html('+');
  
        
        $(this).parents('.item').addClass('open');
        $(this).parents('.item').find('.s-icon').html('-');      
      }
    }

    
  
    

    return false;
    
  });


  


  
  
  
 //  $('.simples-teaser').addClass('is-loaded');

  
  $('.mc-embedded-subscribe').click(function(){
    
    var t = $(this).parent('form');
    var inputEmail = t.find('.mce-EMAIL').val();

    function validateEmail($email) {
      var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
      return emailReg.test( $email );
    }
    
    if(inputEmail!='') {
      if( !validateEmail(inputEmail)) {
        t.find('.error').addClass('show');
      } else {
        t.find('.error').removeClass('show');
         t.submit();
      }
    
    } else {
      t.find('.error').addClass('show');
    }
    
    return false;
    
  });


  ScrollTrigger.create({
      trigger: '.s-resources-mobile .s-resources-nav',
      start: 'center top',
      //endTrigger: '.s-footer',
      //end: 'bottom 50%+=100px',
      onEnter: function() { $('.s-resources-left').addClass('show'); },
      onEnterBack: function() { $('.s-resources-left').removeClass('show'); },
      onLeaveBack: function() { $('.s-resources-left').removeClass('show'); }
    });


  
  


    AOS.init({
      delay: 200,
      duration: 800,
      offset: 20
    });
  
});